import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContentGuardService } from './content-guard.service';
import { ContentLayoutComponent } from './shared/layout/content-layout/content-layout.component';
import { content } from './shared/routes/content.routes';
import { BRAND } from './shared/service/organization.services';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule),
  },
    {
    path: BRAND.BASE_ROUTE,
    component: ContentLayoutComponent,
    children: content,
    canActivate: [ContentGuardService]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
